import fixedNav from './components/theme/fixedNav';
import lazyLoad from './components/theme/lazyLoad';

// Configuration for Testemunhos
const testemSwiperConfig = {
	slidesPerView: 1,
	spaceBetween: 0,
	loop: true,
	navigation: {
		nextEl: '.swiper-button-next',
		prevEl: '.swiper-button-prev',
	},
	centeredSlides: false,
	pagination: {
		el: '.swiper-pagination',
		clickable: true,
	},
	breakpoints: {
		768: {
			slidesPerView: 2,
			slidesPerGroup: 2,
			centeredSlides: false,
		},
		992: {
			slidesPerView: 3,
			slidesPerGroup: 1,
			centeredSlides: true,
		},
	},
};

const shortsSwiperConfig = {
	slidesPerView: 1,
	slidesPerGroup: 1,
	spaceBetween: 20,
	loop: true,
	allowTouchMove: false,
	navigation: {
		nextEl: '.swiper-button-next',
		prevEl: '.swiper-button-prev',
	},
	centeredSlides: true,
	breakpoints: {
		885: {
			loop: true,
			slidesPerView: 3,
		},
		1100: {
			loop: true,
			slidesPerView: 5,
		},
	},
};

const promoSwiperConfig = {
	slidesPerView: 1,
	slidesPerGroup: 1,
	spaceBetween: 0,
	loop: false,
	allowTouchMove: true,
	navigation: {
		nextEl: '.swiper-button-next',
		prevEl: '.swiper-button-prev',
	},
	pagination: {
		el: '.swiper-promo-pages',
		clickable: true,
	},
};

const frontpage = async () => {
	const { default: swiperSlider } =
		await import('./components/theme/swiperSlider');
	swiperSlider('.testemunhos-swiper', testemSwiperConfig);
	swiperSlider('.promo-swiper', promoSwiperConfig);
	swiperSlider('.shorts-swiper', shortsSwiperConfig, true);

	const { default: shortsSlider } =
		await import('./components/theme/shortsSlider');
	shortsSlider();
};

const pageSobreNos = async () => {
	const { expandContent } = await import('./components/theme/blockEquipa');
	expandContent();
};

const servicos = async () => {
	if (document.querySelector('.link-video')) {
		const { modalYoutube } =
			await import('./components/theme/modalYoutube');
		modalYoutube('#videoModal');
	}
};

const initDOMLoaded = () => {
	fixedNav();
	lazyLoad();
	document.querySelector('.home') && frontpage();
	document.querySelector('.page-sobre-dropset') && pageSobreNos();
	document.querySelector('body.single-servicos') && servicos();
};

(() => document.addEventListener('DOMContentLoaded', initDOMLoaded))();
